import { render, staticRenderFns } from "./ReserveSameAppointment.vue?vue&type=template&id=47953d0b"
import script from "./ReserveSameAppointment.vue?vue&type=script&lang=js"
export * from "./ReserveSameAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports